import React, { useState, useRef } from "react";

import { OverlayPanel } from "primereact/overlaypanel";
import NotificationPanelContent from "./NotificationPanelContent";
import "./NotificationWithBadgeStyle.scss";
import notificationicon from "../../Assets/bell_icon.png";

const NotificationWithBadge = () => {
  const op = useRef(null);
  const [notificationsEnabled] = useState(false); // Assuming notifications are enabled by default

  const handleNotificationClick = (e) => {
    if (notificationsEnabled) {
      op.current.toggle(e);
    }
    // Else do nothing
  };

  return (
    <div>
      {/* <div className="h-2rem w-2rem border-circle justify-content-center align-items-center surface-0 p-2 shadow-3 p-overlay-badge" onClick={(e) => op.current.toggle(e)}> */}
      <div
        className="h-2rem w-2rem border-circle justify-content-center align-items-center surface-0 p-2 shadow-3 p-overlay-badge"
        onClick={handleNotificationClick}
      >
        <img
          src={notificationicon}
          alt="notification-icon"
          style={{
            height: "13px",
            width: "11px",
            marginRight: "2px",
            marginLeft: "4px",
            marginTop: "1px",
            marginBottom: "10px",
          }}
          data-testid="notification-icon"
          onClick={handleNotificationClick}
        />
        {/* <Badge
              value="2"
              className="align-items-center"
              style={{backgroundColor:"#1D2965"}}
              data-testid="badge-value"
            /> */}
      </div>
      <OverlayPanel
        ref={op}
        className="panelStyle borderStyle"
        data-testid="overlay-panel"
      >
        <NotificationPanelContent />
      </OverlayPanel>
    </div>
  );
};

export default NotificationWithBadge;
